<template>
    <div class="question-dialogue">
        <div class="question" ref="questionText" tabindex="0">{{question}}
            <Tooltip v-if="help" :text="help"/>
        </div>
        <RadioSelect :options="actionOptions" :value="answer" @inputChanged="onInputChanged($event)"/>
    </div>
</template>

<script>
import RadioSelect from '@/components/form/RadioSelect'
import Tooltip from '@/components/Tooltip'

export default {
    name: 'Question',
    props: {
        options: {
            type: Object
        },
        question: {
            type: String
        },
        questionId: {
            type: Number
        },
        help: {
            type: String,
            default: ''
        },
        answer: {
            type: String,
            default: ''
        }
    },
    components: { RadioSelect, Tooltip },
    computed: {
        actionOptions() {
            return Object.keys(this.options).map(option => ({
                value: option,
                label: this.options[option]
            }))
        }
    },
    methods: {
        onInputChanged(value) {
            this.$emit('optionSelected', value)
        }
    },
    mounted() {
        this.$refs.questionText.focus()
    }
}
</script>
